export function selectBestRoute(productRoutes = [], cartItem, productId) {
  const {
    status,
    productQuantity,
    soldQuantity,
    productIsInStock,
    isPremiumInstallation,
    quoteOnly,
    displayPrice = null,
    combineDisplayPrice = null,
  } = cartItem;
  const validStatus = ["A", "B", "C", "O", "D", "S"];

  let selectedRoute = null;
  let deliveryMessage = null;
  let pickupMessage = null;
  let pickupStatus = null;

  const sellable = productQuantity - soldQuantity;

  if (quoteOnly) {
    return {
      deliveryMessage:
        "Someone will get back to you in 48 hours to schedule delivery & installation",
    };
  }

  if (["A", "B", "S"].includes(status) && sellable <= 2) {
    deliveryMessage = productId
      ? "Contact Us for Delivery Date"
      : "Someone will get in touch with you within 48 hours about the delivery date";
  }

  // ✅ Check warehouse pickup availability
  if (sellable <= 2) {
    if (["A", "B"].includes(status)) {
      pickupMessage = productId ? "On Order" : null;
      pickupStatus = "Not Available for pickup";
    } else if (status === "S") {
      pickupMessage = productId ? "Special Order" : null;
      pickupStatus = "Not Available for pickup";
    }

    return {
      deliveryMessage,
      pickupMessage,
      pickupStatus,
    };
  }

  // ✅ Check if **ALL** routes have routeClassId 4 or 5
  const allRoutesAreQuoteOrOutsideZone = productRoutes.every(
    (route) =>
      (route.routeClassId === 4 || route.routeClassId === 5) &&
      validStatus.includes(status)
  );

  if (allRoutesAreQuoteOrOutsideZone) {
    selectedRoute = productRoutes[0]; // ✅ Take the first delivery route

    if (selectedRoute?.routeClassId === 4) {
      deliveryMessage = "Delivery Requires Quote";
    } else if (selectedRoute?.routeClassId === 5) {
      deliveryMessage =
        "Someone will get back to you in 48 hours to schedule delivery/installation.";
    }

    return {
      // route: selectedRoute,
      deliveryMessage,
      // deliveryDate: null,
      // routeTypeId: null,
      pickupMessage,
      pickupStatus,
    };
  }

  let routeTypeId = 1; // Default to delivery-only (Freestanding)

  // Determine routeTypeId based on installation data.

  if (isPremiumInstallation) {
    routeTypeId = 2; // Needs Installation
  }

  for (const route of productRoutes) {
    if (route.routeTypeId !== routeTypeId) continue; // Skip if routeTypeId doesn't match

    const { routeClassId, isInStock } = route;

    const stockMatch = isInStock === productIsInStock;
    if (
      (routeClassId === 1 ||
        (routeClassId === 2 && combineDisplayPrice
          ? combineDisplayPrice > 500
          : displayPrice > 499)) &&
      stockMatch
    ) {
      selectedRoute = route;
      break;
    } else if ((routeClassId === 1 || routeClassId === 2) && !stockMatch) {
      const routeClass3 = productRoutes.find(
        (r) =>
          r.routeClassId === 3 &&
          validStatus.includes(status) &&
          isInStock == productIsInStock
      );
      if (routeClass3) {
        selectedRoute = routeClass3;

        break;
      }
    } else if (routeClassId == 3 && stockMatch) {
      selectedRoute = route;
      break;
    } else if (
      (routeClassId === 4 || routeClassId === 5) &&
      validStatus.includes(status)
    ) {
      selectedRoute = route;
      break;
    }
  }

  if (selectedRoute) {
    return {
      route: selectedRoute,
      deliveryMessage: deliveryMessage,
      deliveryDate: null,
      routeTypeId: routeTypeId,
      pickupMessage,
      pickupStatus,
    }; // Show calendar
  } else if (routeTypeId === 2) {
    return {
      route: null,
      routeTypeId: routeTypeId,
      deliveryMessage:
        "Someone will get back to you in 48 hours to schedule delivery & installation.",
      pickupMessage,
      pickupStatus,
    };
  } else {
    return {
      route: null,
      routeTypeId: routeTypeId,
      deliveryMessage:
        "Someone will get back to you in 48 hours to schedule delivery",
      deliveryDate: null,
      pickupMessage,
      pickupStatus,
    };
  }
}
